import { PropsWithChildren } from "react";
import logo from "assets/images/logo.svg";
import "./GuestLayout.scss";

export const GuestLayout = ({ children }: PropsWithChildren<{}>) => {
  return (
    <div className="login-page">
      <section className="login">
        <h1 className="login__logo-container">
          <img src={logo} className="login__logo" alt="" />
        </h1>

        {children}
      </section>

      <footer className="login-page__footer">
        <p className="login-page__footer__text">
          AdyenConnector©{new Date().getUTCFullYear()}. All Rights Reserved
        </p>
      </footer>
    </div>
  );
};
